import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

/** Copilot conversation history — list metadata + a single thread's full message blob. */
export function createConversationsQueries(client: StoxlyClient) {
  return createQueryKeys('conversations', {
    // ['conversations', 'list']
    list: {
      queryKey: null,
      queryFn: ({ signal }) => client.conversationsList({ signal }),
    },

    // ['conversations', 'detail', id]
    detail: (id: string) => ({
      queryKey: [id],
      queryFn: ({ signal }) => client.conversationsGet({ params: { id }, signal }),
    }),

    // ['conversations', 'attachmentUrl', id, attachmentId] — short-lived presigned URL for
    // a stored chat attachment; consumers resolve on demand (never cache long).
    attachmentUrl: (id: string, attachmentId: string) => ({
      queryKey: [id, attachmentId],
      queryFn: ({ signal }) =>
        client.conversationsGetAttachmentUrl({ params: { id, attachmentId }, signal }),
    }),
  });
}

export function createConversationsMutations(client: StoxlyClient) {
  return {
    remove: {
      mutationFn: (id: string) => client.conversationsRemove(undefined, { params: { id } }),
    },
    rename: {
      mutationFn: (vars: { id: string; body: Body<'conversationsRename'> }) =>
        client.conversationsRename(vars.body, { params: { id: vars.id } }),
    },
    // Thread config (Phase 2.1): pinned context + thread instructions.
    updateSettings: {
      mutationFn: (vars: { id: string; body: Body<'conversationsUpdateSettings'> }) =>
        client.conversationsUpdateSettings(vars.body, { params: { id: vars.id } }),
    },
  };
}
